import dayjs from "dayjs";
import { getOrderCustomerInputPairs } from "utils/customerInput";
import "./orderCard.scss";

const OrderCard = ({ order, onDetail, onCancel, onConfirmPurchase, onWriteReview }) => {

    // 사용자 입력 옵션 답변(질문-답변). 목록/상세 응답의 스냅샷 위치 차이를 흡수해 수집한다.
    const customerInputPairs = getOrderCustomerInputPairs(order);

    const handleConfirmPurchase = () => {
        if (onConfirmPurchase) {
            onConfirmPurchase(order.id);
        }
    };

    const handleCancelOrder = () => {
        if (onCancel) {
            onCancel(order.id);
        }
    };

    // 취소 가능 여부: can_cancel이 true이고 PENDING 상태일 때만
    const canCancelOrder = order.can_cancel && order.status === "PENDING";

    // 구매확정 가능 여부: 결제 확정 + 배송 완료 상태일 때
    const canConfirmPurchase =
        order.status === "CONFIRMED" &&
        order.fulfillment_status === "DELIVERED";

    // 리뷰 작성 가능 여부: 배송완료 / 구매확정 상태에서만 (취소 등 다른 상태에서는 미노출)
    const canWriteReview =
        ["DELIVERED", "PURCHASE_CONFIRMED"].includes(order.fulfillment_status) &&
        !order.has_review;

    const formatDateTime = (dateString) => {
        return  dayjs(dateString).format("YYYY.MM.DD (ddd) HH:mm");
    };

    const getStatusBadgeClass = (status) => {
        const statusMap = {
            DELIVERED: "delivered",
            PURCHASE_CONFIRMED: "delivered",
            IN_TRANSIT: "in_transit",
            PREPARING: "preparing",
            CANCELLED: "cancelled",
            CONFIRMED: "preparing",
            PENDING: "preparing",
        };
        return statusMap[status] || "preparing";
    };

    // 배송상태(fulfillment_status) 기준으로 표시.
    // 단, 주문 자체가 취소된 경우(status === CANCELLED)는 배송 상태와 무관하게 취소 상태를 우선 노출.
    const isCancelled = order.status === "CANCELLED";
    const displayStatus = isCancelled
        ? "CANCELLED"
        : order.fulfillment_status || "PENDING";
    const displayStatusText = isCancelled
        ? order.status_display || "주문 취소"
        : order.fulfillment_status_display || "주문 접수";

    return (
        <div className="order-card">
            <div className="order-card-header">
                <div className="status-info">
                    <span className={`status-badge ${getStatusBadgeClass(displayStatus)}`}>
                        {displayStatusText}
                    </span>
                    {displayStatus === "DELIVERED" && order.auto_confirm_date && (
                        <span className="auto-confirm-text">
                            {formatDateTime(order.auto_confirm_date)} 자동 구매확정 예정
                        </span>
                    )}
                </div>
            </div>
            <div className="order-number">
                <i className="bi bi-clock"></i>
                <span>주문번호 : {order.order_number}</span>
            </div>
            <div 
                className="order-product" 
                onClick={() => onDetail(order.id)}
            >        
                <div className="product-image">
                    {order.items[0]?.thumbnail || order.product_info?.thumbnail ? (
                        <img src={order.items[0]?.thumbnail || order.product_info?.thumbnail} alt={order.product_info?.name || ""} />
                    ) : (
                        <div className="placeholder-image">
                            <i className="bi bi-image"></i>
                        </div>
                    )}
                </div>
                <div className="product-info">
                    <div className="order-date">
                        <i className="bi bi-clock"></i>
                        <span>{formatDateTime(order.created_at)} 주문</span>
                    </div>
                    <h3 className="product-name">
                        {order.product_info?.brand && `[${order.product_info.brand}] `}
                        {order.product_info?.name || ""}
                        {/* {order.product_info?.items_count > 1 && ` 외 ${order.product_info.items_count - 1}건`} */}
                    </h3>
                    {order.variant_info && (
                        <p className="product-option">
                            {typeof order.variant_info === 'string'
                                ? order.variant_info
                                : order.variant_info.sku || ""}
                        </p>
                    )}
                    {customerInputPairs.map((pair, idx) => (
                        <p className="product-option" key={`ci-${idx}`}>
                            {pair.question} : {pair.answer || "-"}
                        </p>
                    ))}
                    <p className="product-price">
                        {parseInt(order.total_amount || 0).toLocaleString()}원
                    </p>  
                </div>
            </div>
            <div className="btn-wrap btn-wrap-flex gap-8 btn-wrap-no-Xpadding">
                <button
                    onClick={() => onDetail(order.id)}
                    className="btn btn-full btn-small btn-outline-gray100"
                >
                    상세보기
                </button>
                {canCancelOrder && (
                    <button
                        className="btn btn-full btn-small btn-outline-gray100"
                        onClick={handleCancelOrder}
                    >
                        주문취소
                    </button>
                )}
                {canConfirmPurchase && (
                    <button
                        onClick={handleConfirmPurchase}
                        className="btn btn-full btn-small btn-purple400"
                    >
                        구매확정
                    </button>
                )}
                {canWriteReview && (
                    <button
                        onClick={() => onWriteReview && onWriteReview(order)}
                        className="btn btn-full btn-small btn-purple400"
                    >
                        리뷰 작성
                    </button>
                )}
            </div>
        </div>
    );
};

export default OrderCard;
